import { Component, Input, Output } from "rete";
import Socket from "../sockets";
import {
  DropdownControl,
  NumberControl,
  SelectControl,
  SwitchControl
} from "../controls";
import Node from "./node-components/node";

export class DemandMatrixCalc extends Component {
  constructor(component) {
    super("DemandMatrix");
    this.data = {
      render: "vue",
      component: Node,
      props: { type: "calc", comp: component || null }
    };
    this.component = component || null;
  }

  builder(node) {
    const calcInput = new Input("calculation-input", "", Socket["calc"]);
    const matrixInput = new Input(
      "skim-input",
      "Матрица затрат",
      Socket["skim-matrix"]
    );

    const calcOutput = new Output("calculation-output", "", Socket["calc"]);
    const matrixOutput = new Output(
      "demand-output",
      "Матрица корреспонденций",
      Socket["demand-matrix"]
    );

    matrixInput.addControl(
      new DropdownControl(
        this.editor,
        "skimId",
        "skim",
        true,
        "Choose skim matrix",
        this.parentComp
      )
    );

    if (node.data.switch === undefined) node.data.switch = true;

    return node
      .addInput(calcInput)
      .addInput(matrixInput)
      .addControl(
        new SwitchControl(this.editor, "switch", "switcher", false, node)
      )
      .addControl(
        new DropdownControl(
          this.editor,
          "demandId",
          "demand",
          false,
          "Choose demand matrix",
          this.parentComp
        )
      )
      .addControl(
        new SelectControl(
          this.editor,
          "utility_func",
          "utility_func",
          false,
          "Utility func",
          this.component
        )
      )
      .addControl(
        new SelectControl(
          this.editor,
          "balancing",
          "balancing",
          false,
          "Balancing",
          this.component
        )
      )
      .addControl(
        new NumberControl(this.editor, "a", "number", false, "a", true, 1)
      )
      .addControl(
        new NumberControl(this.editor, "b", "number", false, "b", true, 2)
      )
      .addControl(
        new NumberControl(this.editor, "c", "number", false, "c", true, 3)
      )
      .addOutput(calcOutput)
      .addOutput(matrixOutput);
  }

  async worker(node) {
    const calcInput = node.inputs["calculation-input"];

    if (calcInput.connections.length) {
      const { nodes } = await this.editor.toJSON();
      const earlyNode = nodes[calcInput.connections[0].node];
      if (!earlyNode.data.switch) node.data.switch = false;
    }
  }
}
